<template>
   <el-container class="wrapper">888888888888
    <el-header><HeaderDom></HeaderDom></el-header>
    <el-container>
      <el-main class="content-box">
          <div class="content">
            <Breadcrumb></Breadcrumb>
            <router-view></router-view>
          </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
//引入Header Component
import HeaderDom from '@/views/common/layout/HeadDom'
//引入Aside Component
import AsideDom from '@/views/common/layout/AsideDom'
//引入面包屑Breadcrumb
import Breadcrumb from '@/components/breadcrumb'

export default {
  data(){
    return {
      currentUser: this.CONSTANT.currentUser,
    }
  },
  components: {
    HeaderDom,
    AsideDom,
    Breadcrumb
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    },
  },
  created: function(){
    var usertype = this.currentUser.usertype;
    if(usertype == 'COM'){
      this.$router.push({path: '/member/hydw/hydwApplyWeb'});
    }else if(usertype == 'PER'){
      this.$router.push({path: '/member/hygr/hygrApplyWeb'});
    }
  },
  methods: {

  }
};
</script>
<style scoped>
.el-header,
.el-footer {
  background: url(../../../static/images/home/pic_head_red.png) no-repeat;
  background-color: #961617;
  color: #333;
  text-align: center;
  line-height: 50px;
}
.el-header{
  padding:0;
  height:60px !important;
}
.el-main {
  padding: 5px;
  font-size: 14px;
}
.content-box {
    position: absolute;
    left: 0px;
    right: 0;
    top: 60px;
    bottom: 0;
    padding-bottom: 10px;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    background: #f8f8f8;
    display: flex;
    flex-direction: column;
}

.content {
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    width: auto;
    height: 100%;
    padding: 5px 10% 5px 10%;
    overflow-y: auto;
}

.container {
    padding: 30px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/common/IndexWeb.vue